import { ConfidenceScoreOutcomeType } from 'utils/confidence-score';
import { emptyApi } from './empty-api';

// AHA-6796: the server-computed recommendation confidence score. Cookie
// auth + base URL come from empty-api; the endpoint 404s when no instance
// exists yet — RTK surfaces that as an error and the chip renders nothing.
// Exported as an object too so the finalization gate can dispatch
// initiate(..., { forceRefetch: true }) for a live, never-cached read.
export const confidenceApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfidenceScore: builder.query<
      ConfidenceScoreOutcomeType,
      { projectId: number; structureUniqueId?: string }
    >({
      query: ({ projectId, structureUniqueId }) => ({
        url: 'confidence-score',
        params: {
          projectId,
          ...(structureUniqueId ? { structureUniqueId } : {})
        }
      })
    })
  })
});

export const { useGetConfidenceScoreQuery } = confidenceApi;
